import script from "./esManageInstitute.vue?vue&type=script&setup=true&lang=ts"
export * from "./esManageInstitute.vue?vue&type=script&setup=true&lang=ts"

import "./esManageInstitute.vue?vue&type=style&index=0&id=1faca6be&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1faca6be"]])

export default __exports__